import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        BenefitModule: {
          module: () => import('./benefit-lazy.module').then((m) => m.BenefitLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.SdCMSBenefitComponent],
        },
      },
    }),
  ],
})
export class BenefitModule {}
